export default "__VITE_ASSET__BvdaKRBS__"